import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('motoveloz-cookies-accepted');
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('motoveloz-cookies-accepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-zinc-900 border border-zinc-800 rounded-xl p-5 shadow-2xl shadow-black/60 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Shield className="h-6 w-6 text-red-500 flex-shrink-0 mt-0.5 sm:mt-0" />
        <p className="text-zinc-300 text-sm leading-relaxed flex-1">
          Usamos cookies para melhorar sua experiência de navegação e personalizar o conteúdo. Ao continuar, você concorda com nossa{' '}
          <Link to="/politica-de-privacidade" className="text-red-500 hover:text-red-400 font-semibold underline underline-offset-2">
            Política de Privacidade
          </Link>.
        </p>
        <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto">
          <Link
            to="/politica-de-privacidade"
            className="px-4 py-2 border border-zinc-700 text-zinc-400 hover:text-white hover:border-zinc-500 rounded-lg text-sm font-semibold transition-colors text-center flex-1 sm:flex-none"
            data-testid="cookie-learn-more"
          >
            Saiba mais
          </Link>
          <button
            onClick={handleAccept}
            className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-bold transition-colors text-center flex-1 sm:flex-none"
            data-testid="cookie-accept-btn"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
